import { driver } from "driver.js";
import "driver.js/dist/driver.css";
const DRIVER_POPOVER_HIDDEN_CLASS = "mc-help-driver-popover-hidden";
let driverInstance = null;
const ensureDriver = () => {
    if (!driverInstance) {
        driverInstance = driver({
            allowClose: false,
            allowKeyboardControl: false,
            disableActiveInteraction: false,
            overlayOpacity: 0.55,
            overlayColor: "#000",
            stagePadding: 8,
            stageRadius: 10,
            popoverClass: DRIVER_POPOVER_HIDDEN_CLASS,
            showButtons: [],
            smoothScroll: true,
            onDestroyed: () => {
                driverInstance = null;
            },
        });
    }
    return driverInstance;
};
export const showTarget = ({ element, }) => {
    const instance = ensureDriver();
    instance.highlight({
        element,
        disableActiveInteraction: false,
        popover: {
            popoverClass: DRIVER_POPOVER_HIDDEN_CLASS,
            showButtons: [],
        },
    });
};
const cleanupDriverArtifacts = () => {
    document.body.classList.remove("driver-active", "driver-no-scroll");
    document.documentElement.classList.remove("driver-active", "driver-no-scroll");
    document.querySelectorAll(".driver-overlay").forEach((node) => node.remove());
};
export const hide = () => {
    driverInstance?.destroy();
    driverInstance = null;
    cleanupDriverArtifacts();
};
export const destroy = () => {
    hide();
};
export const refresh = () => {
    driverInstance?.refresh();
};
